export default "__VITE_ASSET__23c66c37__"